import React, { useState } from "react";
import Form from "./form";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Title from "./title";
import Checkbox from "./checkbox";

import Box from "./box";

export default function Customs({ person }) {
  const nextUrl = "/apply/battery-powered-video";
  const submitUrl = "/api/applications/v4/application/customs/";
  const name = "acknowledge_customs";
  const [form, setForm] = useState({ [name]: false, errors: null });
  return (
    <Page>
      <PageHeader title="The Battery Customs" tagline="Here’s a simple guide for how we do things.">
        <Title>Conduct</Title>
        <P style={{ marginBottom: '1rem' }}>
          Please show respect and decency to Members, guests, staff, decor, and every inch of The Battery. It’s your and it’s ours. Let’s make it an amazing place to spend our hours.
        </P>
        <Title>Check Egos</Title>
        <P style={{ marginBottom: '1rem' }}>
          Members should check their coats & egos at the door.
        </P>
        <Title>New Friends</Title>
        <P style={{ marginBottom: '1rem' }}>
          We encourage Members to invite up to three guests at a time. Members should announce guests at reception and introduce them to other Members. We'd hate for them to get lost so please do stick by their side and ensure they leave with you.
        </P>
        <Title>
          Privacy
        </Title>
        <P style={{ marginBottom: '1rem' }}>
          We value the privacy and escape that The Battery offers. We ask that Members refrain from taking, posting, or tagging people in photos. That's what the photo booth is for, after all.
        </P>
        <Title>Unitasking</Title>
        <P style={{ marginBottom: '1rem' }}>
          We encourage Members to put away their cell phones and computers while in public areas. Laptops and work devices are welcome in all spaces, just during less social hours.
        </P>
      </PageHeader>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} showBack={false} submitUrl={submitUrl}>
        <Box>
          <Checkbox
            label="I agree to adhere by these customs "
            name="acknowledge_customs_ind"
            form={form}
            setForm={setForm}
          />
        </Box>
      </Form>
    </Page>
  );
}
